export default (expiries_at) => {
  let offset = new Date().getTimezoneOffset();
  offset = offset < 0 ? Math.abs(offset) : offset * -1;
  const date = new Date(new Date(expiries_at).getTime() + offset * 60 * 1000);

  return date;
};
